import { t } from "../../i18n";
// material-ui
import { Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

function AuthFooter() {
  return <Stack direction="row" justifyContent="space-between" sx={{
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden'
  }}>
            <Typography variant="subtitle2" component={Link} href="https://www.cardio-id.com" target="_blank" underline="hover">{t("www.cardio-id.com")}</Typography>
            <Typography variant="subtitle2" component={Link} href="https://www.cardio-id.com" target="_blank" underline="hover">{t("2025 © CardioID Technologies Lda.")}</Typography>
        </Stack>;
}
export default AuthFooter;
